import React from 'react';
import { Box, IconButton, Tooltip, Typography, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSnackbar } from 'notistack';

// A raw token value shown in full (no masking) in a monospace box with a copy button.
// Used by the testing product's token views so tokens can be replayed in curl/Postman.
const TokenField = ({ label, value, caption }) => {
  const { enqueueSnackbar } = useSnackbar();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value || '');
      enqueueSnackbar(`${label} copied`, { variant: 'success' });
    } catch {
      enqueueSnackbar('Copy failed', { variant: 'error' });
    }
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
        <Typography variant="overline" color="text.secondary">{label}</Typography>
        {value && (
          <Tooltip title="Copy">
            <IconButton size="small" onClick={copy}><ContentCopyIcon fontSize="small" /></IconButton>
          </Tooltip>
        )}
      </Stack>
      <Box
        component="pre"
        sx={{
          m: 0,
          p: 1.5,
          bgcolor: '#1a202c',
          color: '#68d391',
          borderRadius: 2,
          overflow: 'auto',
          fontSize: 12.5,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all'
        }}
      >
        {value || '— (not present in session)'}
      </Box>
      {caption && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {caption}
        </Typography>
      )}
    </Box>
  );
};

export default TokenField;
